var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{staticStyle:{"border-radius":"5px","padding-bottom":"0","padding-top":"0"},attrs:{"color":"danger","type":"gradient","icon":"sms"},on:{"click":function($event){return _vm.smsGonder()}}},[_vm._v("Sms At")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }